/** Right-click equip (Bedrock): armour / elytra swap with the worn piece, a shield swaps with the off-hand (pure). */
import { I } from '../itemIds';
import { itemDef } from '../itemdb';
import { cloneStack, isEmpty, setStack, clearStack, type Stack } from '../types';

export interface EquipInv { held: Stack; armor: Stack[]; offhand: Stack }

/** Swap the held item into its slot; true when it was equippable. */
export function equipHeld(inv: EquipInv): boolean {
  const h = inv.held;
  if (isEmpty(h)) return false;
  let target: Stack | null = null;
  if (h.id === I.SHIELD) target = inv.offhand;
  else {
    const a = itemDef(h.id).armor;
    if (a && inv.armor[a.slot]) target = inv.armor[a.slot];
  }
  if (!target) return false;
  const worn = cloneStack(target);
  setStack(target, h);
  if (isEmpty(worn)) clearStack(h); else setStack(h, worn);
  return true;
}
